/**
 * Flag indicating whether the Soft PIP state has been processed to avoid
 *  race condition between multiple attempts to restore the player state.
 */
export const IS_SOFT_PIP_STATE_PROCESSED = 'isSoftPIPStateProcessed';
